import { DataService } from '@/services/DataService.js'

export const namespaced = true

export const state = {
  products: [{
    id: 235234, // идентификатор товара
    name: 'Аккумулятор свинцовый СК', // наименование товара
    market_price: '734.64', // Рыночная цена, RUB
    unit: 'шт.'
  }, {
    id: 235235,
    name: 'Фирмы, производящие услуги по установке пластиковых окон',
    market_price: '1534',
    unit: 'услуга'
  }, {
    id: 235236,
    name: 'Круглогубцы',
    market_price: '153.34',
    unit: 'шт.'
  }, {
    id: 235237,
    name: 'Сверло по бетону твердосплавное d=8 мм',
    market_price: '200.43',
    unit: 'шт.'
  }, {
    id: 235238,
    name: 'Толщиномер многофункциональный электромагнитный для покрытий и материалов "Константа К5"',
    market_price: '2434.50',
    unit: 'шт.'
  }, {
    id: 235239,
    name: 'Труба водогазопроводная 100х4, наружный диаметр (мм) 114 ст. Ст3сп ГОСТ 3262-75',
    market_price: '10534.00',
    unit: 'шт.'
  }, {
    id: 235240,
    name: 'Компьютерная система металлографической микроскопии Micro Vision',
    market_price: '150304.00',
    unit: 'шт.'
  }, {
    id: 235241,
    name: 'Газоаналитическая компьютерная система Micro-Sensor-Technologie FMK Sat-Ex/FTT/R мониторинга цианидов (HCN) атмосферы рабочих мест на уровне ПДК (0,3 мг/м3=0,27 ppm) на базе информационной сетевой технологии LON (Link Operating Network)',
    market_price: '245400.00',
    unit: 'шт.'
  }, {
    id: 235242,
    name: 'Денситометр "Сорбфил" (б/компьютера и принтера)',
    market_price: '6524.23',
    unit: 'шт.'
  }, {
    id: 235243,
    name: 'Трактор колесный Т-30-70',
    market_price: '1600534',
    unit: 'шт.'
  }, {
    id: 235244,
    name: 'Трактор Valtra N93H универсальный для ЖКХ и дорожных компаний и служб',
    market_price: '2550340.50',
    unit: 'шт.'
  }, {
    id: 235245,
    name: 'Автомобиль УАЗ 315195-025 UAZ Hunter',
    market_price: '800000',
    unit: 'шт.'
  }, {
    id: 235246,
    name: 'Кнопки канцелярские Велент, артикул К10/100, диаметр (мм) 10, в упаковке 100 шт. ТУ 9692-004-32943536-00',
    market_price: '94.24',
    unit: 'упаковка'
  }, {
    id: 235247,
    name: 'Бумага индикаторная лакмусовая красная pH 5,0-8,0, в упаковке 100 штук ТУ 6-09-3403-78',
    market_price: '345.50',
    unit: 'упаковка'
  }, {
    id: 235248,
    name: 'Бумага Epson SO41261 матовая, формат А3, в пачке 50 листов',
    market_price: '454',
    unit: 'упаковка'
  }, {
    id: 235249,
    name: 'Принтер линейно-матричный Oki Microline MX-150',
    market_price: '5621.40',
    unit: 'шт.'
  }]
}

export const mutations = {
  UPDATE_PRODUCTS (state, data) {
    // В массивах state.products.concat(data) реактивность не работает.
    // Так остальные не узнают о апдейте массива
    state.products = [...state.products, ...data]
  },
  SET_PRODUCTS (state, data) {
    state.products = data
  }
}

export const getters = {
  products (state) {
    return state.products
  },
  product (state) {
    return (id) => {
      return state.products.find((p) => {
        return p.id === id
      })
    }
  }
}

export const actions = {
  async load ({ commit, getters }) {
    const { data: { products } } = await DataService.getProducts()
    commit('UPDATE_PRODUCTS', products)
  }
}
